// extracted by mini-css-extract-plugin
export var md = "_5f-4";
export var semantic = "_5f-5";
export var sm = "_5f-3";
export var text = "_5f-6";
export var toggleInput = "_5f-0";
export var toggleSwitch = "_5f-1";
export var xs = "_5f-2";